export class EctRow {
  modelID: number;
  rowID: number;
  columnID: number;
  value: string;
}
